import React, { Component } from "react";
import { Col, Modal, Row, Input, Tabs, Spin } from "antd";
import { LoadablePointCloud } from "./types/LoadablePointCloud";
import { milton_obj_arr_july_2025 } from './Helpers/lidarPaths/miltonga';
import {losangeles_ca_obj_arr_december_2025} from "./Helpers/lidarPaths/losangeles_ca";
import { arlington_paths_2025 } from "./Helpers/lidarPaths/arlingtontx";
import {springfield_obj_arr_2025} from "./Helpers/lidarPaths/springfieldmo";
import {  maplewood_obj_arr_2026 } from "./Helpers/lidarPaths/maplewoodmo";
import { florissantmo_obj_arr_2026 } from "./Helpers/lidarPaths/florissantmo";
import {montana_sample} from './Helpers/lidarPaths/montana'
import {  longbeach_backpack_2026, longbeach_paths_2026 } from "./Helpers/lidarPaths/longbeach_ca_sample";

const { Search } = Input;

interface State {
    pointClouds: LoadablePointCloud[],
    selected?: LoadablePointCloud,
    loadedPointCloudURL: string;
    visible: boolean,
    searchTerm: string,
    isLoading: boolean,
}

interface Props {
    onLoad: (pointCloud: LoadablePointCloud) => void
    getAccessTokenSilently: () => Promise<string>
    onPointCloudsLoaded?: (pointClouds: LoadablePointCloud[]) => void
}
export default class LoadPointCloudModal extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        // https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/milton_ga_processed/07072025A_6440_001-002/metadata.json
        // https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/milton_ga/07062025A/metadata.json
        this.state = {
            pointClouds: [
                ...longbeach_backpack_2026,
                  {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/Helena_MT2024/10162024A`,
                    name: "Helena addendum lidar file 1",
                    description: "file 1 of new lidar data provided by helena",
                    date_uploaded: new Date(`11/21/2024`),
                    data_identifier: 'helenamt',
                    collector: 'NV5',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/Helena_MT2024/10162024B`,
                    name: "Helena addendum lidar file 2",
                    description: "file 2 of new lidar data provided by helena",
                    date_uploaded: new Date(`11/21/2024`),
                    data_identifier: 'helenamt',
                    collector: 'NV5',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/Helena_MT2024`,
                    name: "Helena addendum lidar file 3",
                    description: "file 3 of new lidar data provided by helena",
                    date_uploaded: new Date(`11/21/2024`),
                    data_identifier: 'helenamt',
                    collector: 'NV5',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/minessota`,
                    name: "Minessota lidar data",
                    description: "Scan of sample Minessota",
                    date_uploaded: new Date(`4/12/2024`),
                    data_identifier: 'minessota',
                    collector: 'NV5',
                    projection: '+proj=utm +zone=15 +ellps=GRS80 +datum=NAD83 +units=m +no_defs',

                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/minnesota_hastings`,
                    name: "Hastings Minessota lidar data",
                    description: "Scan of sample Minessota",
                    date_uploaded: new Date(`4/12/2024`),
                    data_identifier: 'minessota',
                    collector: 'NV5',
                    projection: '+proj=utm +zone=15 +ellps=GRS80 +datum=NAD83 +units=m +no_defs',

                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/stapleton-2.1`,
                    name: "Stapleton, NY",
                    description: "A two pass scan of Stapleton alongside the shore.",
                    date_uploaded: new Date(`10/13/2021`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_1=40.66666666666666 +lat_2=41.03333333333333 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_def`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-19`,
                    name: "Helena September 19",
                    description: "Scan of Helena tracks on september 19",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-20-b`,
                    name: "Helena September 20th",
                    description: "Scan of Helena tracks on september 20",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/WTC Busway`,
                    name: "WTC Busway",
                    description: "WTC Busway scan",
                    date_uploaded: new Date(`11/28/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',// 
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-22`,
                    name: "Helena September 22",
                    description: "Scan of Helena tracks on September 22",
                    date_uploaded: new Date(`11/17/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-23`,
                    name: "Helena September 23 version a",
                    description: "Scan of Helena tracks on September 23 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-23-b`,
                    name: "Helena September 23 version b",
                    description: "Scan of Helena tracks on September 23 version b",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-24-a`,
                    name: "Helena September 24 version a",
                    description: "Scan of Helena tracks on September 24 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-25-a`,
                    name: "Helena September 25 version a",
                    description: "Scan of Helena tracks on September 25 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-25-b`,
                    name: "Helena September 25 version b",
                    description: "Scan of Helena tracks on September 25 version b",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-26-a`,
                    name: "Helena September 26 version a",
                    description: "Scan of Helena tracks on September 26 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-27-a`,
                    name: "Helena September 27 version a",
                    description: "Scan of Helena tracks on September 27 version a",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-27-b`,
                    name: "Helena September 27 version b",
                    description: "Scan of Helena tracks on September 27 version b",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-28-a`,
                    name: "Helena September 28 version a",
                    description: "Scan of Helena tracks on September 28 version a",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-sep-28-b`,
                    name: "Helena September 28 version b",
                    description: "Scan of Helena tracks on September 28 version b",
                    date_uploaded: new Date(`11/15/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-oct-2-a`,
                    name: "Helena October 2 version a",
                    description: "Scan of Helena tracks on October 2 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-oct-2-b`,
                    name: "Helena October 2 version b",
                    description: "Scan of Helena tracks on October 2 version b",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-oct-3-a`,
                    name: "Helena October 3 version a",
                    description: "Scan of Helena tracks on October 3 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-oct-3-b`,
                    name: "Helena October 3 version b",
                    description: "Scan of Helena tracks on October 3 version b",
                    date_uploaded: new Date(`11/17/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
                {
                    url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/helena-oct-5-a`,
                    name: "Helena October 5 version a",
                    description: "Scan of Helena tracks on October 5 version a",
                    date_uploaded: new Date(`11/13/2023`),
                    data_identifier: 'helenamt',
                    collector: 'tectonic',
                    projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
                },
            ],
            visible: false,
            searchTerm: "",
            selected: {
                url: `https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/Helena_MT2024/10162024A`,
                name: "Helena addendum lidar file 1",
                description: "file 1 of new lidar data provided by helena",
                date_uploaded: new Date(`11/21/2024`),
                data_identifier: 'helenamt',
                collector: 'NV5',
                projection: `+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs`,
            },
            loadedPointCloudURL: "https://citian-public-v2.s3.us-east-2.amazonaws.com/lidar-samples/Helena_MT2024/10162024A",
            isLoading: true,
        };
    }

    async componentDidMount(): Promise<void> {
        await this.loadPointClouds();
    }

    /**
     * @description Fetches every dataset's point clouds, stores them and tells
     * the app. Also called again when a requested point cloud is missing.
     * @return {Promise<LoadablePointCloud[]>} The point clouds, empty on failure
     */
    async loadPointClouds(): Promise<LoadablePointCloud[]> {
        // load all point clouds from the s3
        try {
            // use Promise.all
            const [springfield, florissant, milton, arlington, losangeles, longbeach2026, maplewood, montana] = await Promise.all([
                springfield_obj_arr_2025(this.props.getAccessTokenSilently),
                florissantmo_obj_arr_2026(this.props.getAccessTokenSilently),
                milton_obj_arr_july_2025(this.props.getAccessTokenSilently),
                arlington_paths_2025(this.props.getAccessTokenSilently),
                losangeles_ca_obj_arr_december_2025(this.props.getAccessTokenSilently),
                longbeach_paths_2026(this.props.getAccessTokenSilently),
                maplewood_obj_arr_2026(this.props.getAccessTokenSilently),
                montana_sample(this.props.getAccessTokenSilently),
            ]);
            const allPointClouds = [
                ...losangeles,
                ...springfield,
                ...florissant,
                ...milton,
                ...arlington,
                ...longbeach2026,
                ...maplewood,
                ...montana,
                ...this.state.pointClouds,
            ];

            // deduplicate by URL
            const uniquePointClouds = allPointClouds.filter(
                (pc, index, self) => index === self.findIndex(t => t.url === pc.url)
            );
    
            this.setState({ pointClouds: uniquePointClouds, isLoading: false }, () => {
                this.props.onPointCloudsLoaded?.(uniquePointClouds);
            });
            return uniquePointClouds;
        } catch (error) {
            console.error('Failed to load point clouds:', error);
            this.setState({ isLoading: false });
            return [];
        }
    }

    showModal() {
        this.setState({ visible: true });
    }

    hideModal() {
        this.setState({ visible: false });
    }

    onLoadButton() {
        if (this.state.selected) {
            this.props.onLoad(this.state.selected);
            this.setState({ visible: false, loadedPointCloudURL: this.state.selected.url });
        }
    }

    onSearchChange = (value: string) => {
        this.setState({ searchTerm: value });
    }

    getFilteredPointClouds = () => {
        const { pointClouds, searchTerm } = this.state;
        if (!searchTerm.trim()) {
            return pointClouds;
        }

        const lowerSearchTerm = searchTerm.toLowerCase();
        return pointClouds.filter(pc =>
            pc.name.toLowerCase().includes(lowerSearchTerm) ||
            pc.description.toLowerCase().includes(lowerSearchTerm) ||
            pc.collector.toLowerCase().includes(lowerSearchTerm) ||
            (pc.data_identifier && pc.data_identifier.toLowerCase().includes(lowerSearchTerm))
        );
    }
    /* Group point clouds by data_identifier */
    getGroupedPointClouds = () => {
        const filteredPointClouds = this.getFilteredPointClouds();
        const grouped: { [key: string]: LoadablePointCloud[] } = {};

        filteredPointClouds.forEach(pc => {
            const identifier = pc.data_identifier || 'Other';
            if (!grouped[identifier]) {
                grouped[identifier] = [];
            }
            grouped[identifier].push(pc);
        });

        return grouped;
    }
    /* Helper to get user friendly tab labels */
    getTabLabel = (dataIdentifier: string, count: number) => {
        const labelMap: { [key: string]: string } = {
            'arlington_tx': 'Arlington TX',
            'milton_ga': 'Milton GA',
            'longbeach_ca': 'Port of Long Beach',
            'helenamt': 'Helena MT',
            'la_pilot': 'LA Pilot',
            'losangeles_ca': 'Los Angeles CA',
            'minessota': 'Minnesota',
            'springfield_mo': 'Springfield MO',
            'maplewood_mo': 'Maplewood MO',
            'montana': 'Montana',
            'Other': 'Other'
        };

        const displayName = labelMap[dataIdentifier] || dataIdentifier;
        return `${displayName} (${count})`;
    }
    /* Helper to format date as YYYY-MM for grouping */
    formatDateForGrouping = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    }
 
    /* Helper to get user friendly date tab labels */
    getDateLabel = (dateKey: string, count: number) => {
        const [year, month] = dateKey.split('-');
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        return `${monthNames[parseInt(month) - 1]} ${year} (${count})`;
    }

    /* Group point clouds by data_identifier and then by upload date (month-year) */
    getGroupedPointCloudsByDate = () => {
        const groupedByIdentifier = this.getGroupedPointClouds();
        const groupedByDateAndIdentifier: { [key: string]: { [key: string]: LoadablePointCloud[] } } = {};

        Object.entries(groupedByIdentifier).forEach(([dataIdentifier, pointClouds]) => {
            groupedByDateAndIdentifier[dataIdentifier] = {};

            pointClouds.forEach(pc => {
                const dateKey = this.formatDateForGrouping(pc.date_uploaded);
                if (!groupedByDateAndIdentifier[dataIdentifier][dateKey]) {
                    groupedByDateAndIdentifier[dataIdentifier][dateKey] = [];
                }
                groupedByDateAndIdentifier[dataIdentifier][dateKey].push(pc);
            });
        });

        return groupedByDateAndIdentifier;
    }

    render() {
        const groupedPointCloudsByDate = this.getGroupedPointCloudsByDate();
        const { TabPane } = Tabs;

        const renderPointCloudList = (pointClouds: LoadablePointCloud[]) => (
            <div style={{ height: "100%", maxHeight: 300, overflow: "auto", background: "#242424" }}>
                {pointClouds.length === 0 ? (
                    <div style={{ padding: 16, color: "#888", textAlign: "center" }}>
                        <i>No point clouds found in this category.</i>
                    </div>
                ) : (
                    pointClouds.map((pc) =>
                        <div
                            key={pc.url}
                            onClick={() => {
                                if (this.state.loadedPointCloudURL !== pc.url) {
                                    if (this.state.selected?.url === pc.url) {
                                        // clicked on already selected item → cancel selection
                                        this.setState({ selected: undefined });
                                    } else {
                                        this.setState({ selected: pc });
                                    }
                                }
                            }}
                            style={{
                                background: this.state.loadedPointCloudURL === pc.url
                                    ? "#444"
                                    : this.state.selected?.url === pc.url
                                        ? "#177DDC"
                                        : "#141414",
                                margin: 8,
                                padding: 8,
                                cursor: this.state.loadedPointCloudURL === pc.url ? "not-allowed" : "pointer",
                                color: this.state.loadedPointCloudURL === pc.url ? "#888" : "#fff",
                            }}
                        >
                            {pc.name}<i style={{ color: "gray", float: "right" }}>{pc.date_uploaded.toLocaleDateString()}</i>
                        </div>
                    )
                )}
            </div>
        );

        const renderDateTabs = (dateGroups: { [key: string]: LoadablePointCloud[] }) => {
            const sortedDateKeys = Object.keys(dateGroups).sort((a, b) => b.localeCompare(a)); // Sort by date descending

            if (sortedDateKeys.length === 1) {
                // If there's only one date group, render the list directly without inner tabs
                return renderPointCloudList(dateGroups[sortedDateKeys[0]]);
            }

            return (
                <Tabs
                    defaultActiveKey={sortedDateKeys[0]}
                    size="small"
                    style={{ height: "100%" }}
                    tabBarStyle={{ marginBottom: 8, backgroundColor: "#1a1a1a", paddingLeft: 8 }}
                >
                    {sortedDateKeys.map((dateKey) => (
                        <TabPane
                            tab={this.getDateLabel(dateKey, dateGroups[dateKey].length)}
                            key={dateKey}
                            style={{ height: "calc(100% - 40px)" }}
                        >
                            {renderPointCloudList(dateGroups[dateKey])}
                        </TabPane>
                    ))}
                </Tabs>
            );
        };

        return (
            <Modal
                title={"Load Point Cloud"}
                width={800}
                visible={this.state.visible}
                okText={"Load"}
                okButtonProps={{ 
                    disabled: this.state.isLoading || this.state.selected === undefined || this.state.selected?.url === this.state.loadedPointCloudURL 
                }}
                onOk={() => this.onLoadButton()}
                onCancel={() => this.setState({ visible: false })}
            >
                {this.state.isLoading ? (
                    <div style={{ height: 450, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Spin size="large" tip="Loading point clouds..." />
                    </div>
                ) : (
                    <div style={{ height: '100%', maxHeight: 450 }}>
                        <div style={{ marginBottom: 8 }}>
                            <Search
                                placeholder="Search point clouds by name, description, collector, or identifier..."
                                allowClear
                                onChange={(e) => this.onSearchChange(e.target.value)}
                                style={{ width: "100%" }}
                            />
                        </div>
                        <Row style={{ height: "calc(100% - 40px)" }}>
                            <Col span={18} style={{ height: "100%" }}>
                                {Object.keys(groupedPointCloudsByDate).length === 0 ? (
                                    <div style={{ height: "100%", background: "#242424", margin: 8, padding: 16, color: "#888", textAlign: "center" }}>
                                        <i>No point clouds found matching your search.</i>
                                    </div>
                                ) : (
                                    <div style={{ height: "100%", margin: 8 }}>
                                        <Tabs
                                            defaultActiveKey={Object.keys(groupedPointCloudsByDate)[0]}
                                            size="small"
                                            style={{ height: "100%" }}
                                            tabBarStyle={{ marginBottom: 8 }}
                                        >
                                            {Object.entries(groupedPointCloudsByDate).map(([dataIdentifier, dateGroups]) => {
                                                const totalCount = Object.values(dateGroups).reduce((sum, pcs) => sum + pcs.length, 0);
                                                return (
                                                    <TabPane
                                                        tab={this.getTabLabel(dataIdentifier, totalCount)}
                                                        key={dataIdentifier}
                                                        style={{ height: "calc(100% - 40px)" }}
                                                    >
                                                        {renderDateTabs(dateGroups)}
                                                    </TabPane>
                                                );
                                            })}
                                        </Tabs>
                                    </div>
                                )}
                            </Col>
                            <Col span={6}>
                                <div style={{ width: "100%", height: "100%", background: "#242424", margin: 8, padding: 8 }}>
                                    {this.state.selected === undefined ?
                                        <i>Select a point cloud to view description</i> :
                                        <>{this.state.selected.description}</>}
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </Modal>
        );
    }
}